import { useTranslation } from "react-i18next";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useState } from "react";
import {Consts} from "../pages/consts";

const alcoFrequencyRadios = [
  "daily_or_almost_daily",
  "three_or_four_times_a_week",
  "once_or_twice_a_week",
  "one_or_three_times_a_month",
];

const AlcoholFrequency = ({ onSaveAlcoFrequency, showDialog }) => {
  const { t: t } = useTranslation();

  const [alcoFrequency, setAlcoFrequency] = useState("");

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel dialog-narrow">
        <header className="w3-container w3-padding-small w3-center">
          <p>{t("frequency")}</p>
        </header>
        <div className="w3-container w3-padding-small w3-margin-left">
          <RadioGroup
            aria-labelledby="alcohol-frequencies-group"
            name="alcohol-frequencies-group"
            value={alcoFrequency}
            defaultValue={alcoFrequency}
            onChange={(e) => setAlcoFrequency(e.target.value)}
          >
            {alcoFrequencyRadios?.map((radioLabel) => {
              return (
                <FormControlLabel
                  key={radioLabel}
                  value={radioLabel}
                  control={<Radio />}
                  label={<label>{t(radioLabel)}</label>}
                />
              );
            })}
          </RadioGroup>
        </div>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            {alcoFrequency && (
              <button
                className="w3-btn w3-round-xlarge w3-theme-d5 "
                onClick={() => onSaveAlcoFrequency(alcoFrequency)}
              >
                {t("submit")}
              </button>
            )}
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={() => onSaveAlcoFrequency(null)}
            >
              {t("cancel")}
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default AlcoholFrequency;
